import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { localeStore } from '@/shared/i18n/locale-store';
import { themeStore } from '@/shared/lib/theme/theme-store';
import { App } from './app';
import './styles.css';

localeStore.apply();
themeStore.apply();

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');
createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
